import type { SessionUser } from '~/utils/sessions.server.ts';

export const getPaymentsUserDisplayName = (user: SessionUser): string => {
  if (user.firstName) {
    return `${user.firstName} ${user.lastName ?? ''}`.trim();
  }

  return user.email;
};
